var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 11.376V9.75098C42.1839 8.4592 41.6889 7.2214 40.8106 6.30798C39.9323 5.39455 38.7421 4.87973 37.5 4.87598H6.25C5.00791 4.87973 3.81772 5.39455 2.93942 6.30798C2.06113 7.2214 1.56611 8.4592 1.5625 9.75098V35.751C1.56611 37.0428 2.06113 38.2805 2.93942 39.194C3.81772 40.1074 5.00791 40.6222 6.25 40.626H7.8125",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9463 12.9985H13.8662C11.3858 12.9985 9.375 15.0898 9.375 17.6694V42.4527C9.375 45.0323 11.3858 47.1235 13.8662 47.1235H43.9463C46.4267 47.1235 48.4375 45.0323 48.4375 42.4527V17.6694C48.4375 15.0898 46.4267 12.9985 43.9463 12.9985Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4189 25.4101C38.0785 25.4101 39.4238 24.0209 39.4238 22.3073C39.4238 20.5937 38.0785 19.2046 36.4189 19.2046C34.7594 19.2046 33.4141 20.5937 33.4141 22.3073C33.4141 24.0209 34.7594 25.4101 36.4189 25.4101Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4131 37.7974L24.9023 29.0234C24.3583 28.4644 23.6306 28.1408 22.866 28.118C22.1015 28.0952 21.3572 28.3748 20.7832 28.9005L9.375 39.3686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9004 47.1245L37.4814 35.1675C38.0144 34.6209 38.7231 34.299 39.4708 34.2639C40.2185 34.2289 40.9522 34.4831 41.5303 34.9776L48.4365 40.92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOutline);
export default __webpack_public_path__ + "static/media/image_outline.c9dc947c.svg";
export { ForwardRef as ReactComponent };